import clsx from 'clsx'
import React, {FC} from 'react'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {UserModel} from 'src/app/modules/auth/models/UserModel'
import {RootState} from 'src/setup'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, QuickLinks, Search} from '../../../partials'
import {useLayout} from '../../core'
import {Avatar, Menu, MenuProps, Popover, Typography} from 'antd'
import {Link} from 'react-router-dom'
import axios from 'axios'
import {toast} from 'react-toastify'
import * as auth from '../../../../app/modules/auth/redux/actions'
const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const LOGOUT_MODEL = `${API_URL}/logout`
const Topbar: FC = () => {
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  console.log(user, 'profile')
  const {name, email} = user?.data
  const {config} = useLayout()
  let key: any = user?.data?.vendor
  let venderId: any = user?.data?.id

  typeof window !== 'undefined' ? sessionStorage.setItem('vendorRoleId', key) : ''
  typeof window !== 'undefined' ? sessionStorage.setItem('vendorId', venderId) : ''
  const dispatch = useDispatch()
  const logout = () => {
    axios
      .get(LOGOUT_MODEL)
      .then((response) => {
        toast.success('Logout successfully')
        dispatch(auth.actions.logout())
      })
      .catch((error) => {
        console.error(error)
      })
  }
  let firstStringChar = name.charAt(0) //H
  const profileItems: MenuProps['items'] = [
    {
      label: <Link to={'/profile'}>My Profile</Link>,
      key: '0',
    },
    {
      label: <a onClick={logout}>Sign Out</a>,
      key: '1',
    },
  ]
  const content = (
    <div>
      <div className='d-flex flex-column'>
        <div className='fw-bolder d-flex align-items-center fs-5'>{name}</div>
        <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
          {email}
        </a>
      </div>
      <Menu style={{width: 150}} mode='vertical' items={profileItems} />
    </div>
  )
  return (
    <div style={{display: 'flex', alignItems: 'center', gap: 16}}>
      <Typography.Text strong style={{color: '#fff', fontSize: 12}}>
        {user?.data?.designation}
      </Typography.Text>
      <Typography.Text strong style={{color: '#fff'}}>
        {user?.data?.branch?.title}
      </Typography.Text>

      <Popover content={content} trigger='click' placement='bottomRight'>
        <Avatar
          style={{
            cursor: 'pointer',
            verticalAlign: 'middle',
          }}
          size='large'
        >
          {name.split(' ').map((word) => word[0])}
        </Avatar>
      </Popover>
    </div>
  )
}

export {Topbar}
